export default "__VITE_ASSET__Cb8rO39M__"